export default "__VITE_ASSET__DKD7JX3C__"